import { Button } from "primereact/button";
import { mainServiceURL } from "../../../redux/services/defines";

type GoogleAuthButtonProps = {
  mode: "login" | "signup";
  nextPath?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
};

const sanitizeNextPath = (value: string | undefined, mode: "login" | "signup") => {
  const fallback = mode === "signup" ? "/dashboard" : "/";

  if (!value) {
    return fallback;
  }

  if (!value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }

  return value;
};

const buildGoogleAuthUrl = (mode: "login" | "signup", nextPath?: string) => {
  const params = new URLSearchParams({
    mode,
    next: sanitizeNextPath(nextPath, mode),
  });

  return `${mainServiceURL}/auth/cognito/social/google?${params.toString()}`;
};

export const GoogleAuthButton = ({
  mode,
  nextPath,
  label,
  disabled = false,
  className = "",
}: GoogleAuthButtonProps) => {
  const computedLabel =
    label || (mode === "signup" ? "Sign up with Google" : "Continue with Google");

  const handleClick = () => {
    window.location.assign(buildGoogleAuthUrl(mode, nextPath));
  };

  return (
    <Button
      type="button"
      label={computedLabel}
      icon="pi pi-google"
      disabled={disabled}
      className={className}
      style={{
        background: "cornsilk",
        borderColor: "#d8cc99",
        color: "#2f2f2f",
      }}
      onClick={handleClick}
    />
  );
};

export default GoogleAuthButton;
